module.exports = __webpack_public_path__ + "static/media/Zombie.9122d825.jpg";